import React from 'react';
import { Layers, Share2, Globe, ArrowRight } from 'lucide-react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: <Layers className="w-10 h-10 text-[#D4AF37] mb-8" />,
      pillar: "Pillar 01",
      title: "Investment Catalyst",
      desc: "We translate complex geological data into high-trust commercial narratives that satisfy the rigor of institutional investment committees."
    },
    {
      icon: <Share2 className="w-10 h-10 text-[#D4AF37] mb-8" />,
      pillar: "Pillar 02",
      title: "Ethical Supply Connector",
      desc: "Positioning your operation for global OEMs and buyers who demand verified ESG compliance and transparent traceability."
    },
    {
      icon: <Globe className="w-10 h-10 text-[#D4AF37] mb-8" />,
      pillar: "Pillar 03",
      title: "Global Procurement Door",
      desc: "Custom digital systems and strategic visibility frameworks that place your mine in front of international decision-makers."
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#fafafa] flex justify-center px-4 scroll-mt-32">
      <div className="w-full max-w-[1440px] bg-zinc-950/95 backdrop-blur-xl text-white rounded-sm shadow-[0_20px_50px_rgba(0,0,0,0.5)] py-24 px-8 md:px-16 border border-white/5 relative overflow-hidden">
        {/* Decorative Background Glow */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#D4AF37]/5 blur-[120px] rounded-full -translate-y-1/2 translate-x-1/3" />
        
        <div className="max-w-3xl mb-20 relative z-10">
          <span className="text-[#D4AF37] text-[11px] font-black uppercase tracking-[0.3em] mb-6 block">Capability Pillars</span>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tighter leading-tight">
            Three Ways We Make Mines Investable and Visible.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative z-10">
          {services.map((service, idx) => (
            <div key={idx} className="flex flex-col group p-6 bg-white/5 backdrop-blur-md border border-white/10 rounded-sm hover:bg-white/10 transition-all duration-500">
              <div className="flex justify-between items-start mb-2">
                <div className="group-hover:scale-110 transition-transform duration-500">
                  {service.icon}
                </div>
                {/* Level 1 Metadata */}
                <span className="text-zinc-600 text-[11px] font-black uppercase tracking-widest">{service.pillar}</span>
              </div>
              <h3 className="text-2xl font-bold mb-5 tracking-tighter uppercase group-hover:text-[#D4AF37] transition-colors">
                {service.title}
              </h3>
              <p className="text-zinc-400 text-[15px] leading-relaxed mb-10 flex-grow">
                {service.desc}
              </p>
              {/* Level 2 Functional Label */}
              <a 
                href="https://wa.me/27839287731"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[13px] font-black uppercase tracking-widest text-white border-b border-zinc-800 pb-4 w-full group-hover:border-[#D4AF37] transition-all bg-transparent whitespace-nowrap"
              >
                Enquire Now
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;